<template>
  <eagle-form
    :form-key="formKey"
  ></eagle-form>
</template>

<script lang="babel" type="text/babel">
import formMixin from '@/components/form/mixins/formMixin'
import formConfig from './contactAppConfigFormConfig'
export default {
  mixins: [formMixin],
  data: () => ({
    formKey: 'contact-app-config-form',
    meta: {},
  }),
  methods: {
    async beforeFormInit() {
      await Promise.all([])
    },
    validateBeforeSave() {
      // TODO
    },
    async readApi() {
      return await this.$api.collection.baseApi.appConfigRead('contact')
    },
    async updateApi(target, formData) {
      return await this.$api.collection.baseApi.appConfigUpdate('contact', formData)
    },
    getFormConfig() {
      return formConfig
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>
